import EventTypes from '@/common/api/definitions/event-types';
import WebhookModel from './webhook-model';

export default class GlobalWebhookModel extends WebhookModel {
    static EventFilters = {
        ...EventTypes,
        invoiceModified: 'invoice-modified',
        invoiceCreated: 'invoice-created',
        invoiceAbandoned: 'invoice-abandoned',
        invoiceVoided: 'invoice-voided',
        invoiceIssued: 'invoice-issued',
        transactionTimeoutResolved: 'transaction-timeout-resolved',
        offsitePaymentCompleted: 'offsite-payment-completed',
        customerMerged: 'customer-merged',
        customerCreated: 'customer-created',
        customerUpdated: 'customer-updated',
        transactionDiscrepancyFound: 'transaction-discrepancy-found',
        transactionAmountDiscrepancyFound: 'transaction-amount-discrepancy-found',
    };

    hydrate(
        {
            id = null,
            status = WebhookModel.Statuses.active,
            eventsFilter = [],
            method = 'POST',
            url = 'https://',
            headers = [],
            query = null,
            body = null,
            credentialHash = null,
        } = {},
    ) {
        super.hydrate(
            {
                method,
                url,
                query,
                body,
                headers,
                credentialHash,
            },
        );
        this.id = id;
        this.status = status;
        this.eventsFilter = eventsFilter;
    }

    getPayload() {
        const payload = super.getPayload();
        payload.status = this.status;
        payload.eventsFilter = this.eventsFilter;

        return payload;
    }

    get isActive() {
        return this.status === WebhookModel.Statuses.active;
    }

    set isActive(value) {
        this.status = value
            ? WebhookModel.Statuses.active
            : WebhookModel.Statuses.inactive;
    }
}
